import React from 'react'
import ReactDOM from 'react-dom'
import { Analytics } from '@vercel/analytics/react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Home from './views/home'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
      <Analytics />
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
